import React, { Fragment, useEffect } from "react";
import NewNavbar from "../../new-components/NewNavbar";
import NewPageHeader from "../../new-components/NewPageHeader";
import NewOverrides from "../../new-components/NewOverrides";
import NewDesignSystem from "../../new-components/NewDesignSystem";
import PersonTable from "../../components/PersonTable";
import NewFooter from "../../new-components/NewFooter";
import NewMadeWith from "../../new-components/NewMadeWith";
import NewScrollTop from "../../new-components/NewScrollTop";

const dummyPersons = [
  {
    id: '1',
    name: 'Ana Maria',
    personId: 'AM001',
    assignedTo: 'Consultant John',
    type: 'Member',
    createdAt: '2024-01-15T10:30:00Z'
  },
  {
    id: '2',
    name: 'Ion Popescu',
    personId: 'IP002',
    assignedTo: 'Consultant Sarah',
    type: 'Consultant',
    createdAt: '2024-01-20T14:15:00Z'
  },
  {
    id: '3',
    name: 'Maria Ionescu',
    personId: 'MI003',
    assignedTo: 'Consultant Alex',
    type: 'Member',
    createdAt: '2024-02-01T09:45:00Z'
  },
  {
    id: '4',
    name: 'Andrei Stefan',
    personId: 'AS004',
    assignedTo: 'Consultant Elena',
    type: 'Member',
    createdAt: '2024-02-10T16:20:00Z'
  },
  {
    id: '5',
    name: 'Elena Vasile',
    personId: 'EV005',
    assignedTo: 'Consultant Mike',
    type: 'Consultant',
    createdAt: '2024-02-15T11:30:00Z'
  }
];

const PersonTablePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Fragment>
      <NewNavbar />
      <NewOverrides />
      <NewDesignSystem />

      <NewPageHeader />
      <PersonTable
        persons={dummyPersons}
        updatePerson={(person) => console.log('Update person', person)}
        deletePerson={(id) => console.log('Delete person', id)}
        blLeft={"d-none"} 
        blRight={"col-lg-10 offset-lg-1"} 
      />
      <NewFooter />
      <NewMadeWith />
      <NewScrollTop />
    </Fragment>
  );
};
export default PersonTablePage;